/* eslint-disable no-unused-vars */
import React from 'react';
import { NavLink } from 'react-router-dom';
import { shadeColor } from '../helpers/helpers';

function NavItem(props) {
  const {
    highlightColour, darkColour, icon, to, title, exact, iconIsFA,
  } = props;

  return (
    <NavLink
      exact={exact}
      className="nav-link group w-full flex h-14 mb-2 items-center"
      to={to}
    >
      <div style={{ backgroundColor: highlightColour }} className="nav-link-active h-full w-1 mr-4" />
      <div style={{ backgroundColor: '#40424b' }} className="nav-link-hover h-full w-1 mr-4" />
      <div style={{ backgroundColor: darkColour }} className="nav-link-normal h-full w-1 mr-4" />
      {iconIsFA
        && <div style={{ color: '#898fa1' }} className="nav-image h-5 w-10 mr-0 text-xl">{icon}</div>}
      {!iconIsFA
      && <img className="nav-image h-5 w-10 object-contain object-left mr-0" src={icon} alt="" />}
      <span id={`${title.replace(/\s/g, '')}_nav`} className="nav-text text-nav-text-normal uppercase text-xs font-semibold">{title}</span>
    </NavLink>
  );
}

export default NavItem;
